// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__2bGnQ","map_heading":"Map_map_heading__1_lva"};